import React, { useEffect, useState } from "react";
import axios from "axios";

// Delivery App (Sends Location to Backend)
const DeliveryApp = () => {
  const [location, setLocation] = useState({ latitude: null, longitude: null });
  useEffect(() => {
    const updateLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLocation({ latitude, longitude });
            axios
              .post("http://localhost:5000/update-location", {
                driverId: "driver-123", // Replace with actual driver ID
                latitude,
                longitude,
              })
              .catch((err) => console.error("Error sending location:", err));
          },
          (error) => console.error("Error fetching location:", error.message)
        );
      } else {
        console.log("Geolocation is not supported by your browser");
      }
    };

    const interval = setInterval(updateLocation, 5000); // Update every 5 sec
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <h2>Delivery Driver App</h2>
      <p>Latitude: {location.latitude}</p>
      <p>Longitude: {location.longitude}</p>
    </div>
  );
};

// End-User App (Fetches Live Location from Backend)
const EndUserApp = () => {
  const [location, setLocation] = useState(null);

  useEffect(() => {
    const fetchLocation = async () => {
      try {
        const response = await axios.get(
          "http://localhost:5000/get-location/driver-123"
        );
        setLocation(response.data);
      } catch (error) {
        console.error("Error fetching location:", error);
      }
    };

    const interval = setInterval(fetchLocation, 5000); // Fetch location every 5 sec
    return () => clearInterval(interval);
  }, []);

  return (
    <div>
      <h2>End-User App (Live Tracking)</h2>
      {location ? (
        <p>
          Driver Location - Latitude: {location.latitude}, Longitude:{" "}
          {location.longitude}
        </p>
      ) : (
        <p>Waiting for location updates...</p>
      )}
    </div>
  );
};

const App = () => (
  <div>
    <DeliveryApp />
    <hr />
    <EndUserApp />
  </div>
);

export default App;
